import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


export class DataNotice extends PureComponent {
    static propTypes = {
      suggestionError: PropTypes.string,
    };

    static defaultProps = {
      suggestionError: null,
    };

    static state = {};

    render() {
      const { suggestionError } = this.props;

      if (!suggestionError) return null;

      return (
        <div className="nodata-notice">
          <h3 className="nodata-notice__message">
            Data temporarily unavailable, please try again later.
          </h3>
        </div>
      );
    }
}

/* ------------- Redux mappings  ------------- */
const mapDispatchToProps = () => ({});
const mapStateToProps = state => ({
  suggestionError: state.timetables[state.timetables.searchMode].routeAutosuggest.suggestionError,
});
export default connect(mapStateToProps, mapDispatchToProps)(DataNotice);